import { createTheme } from '@mui/material/styles';

// Custom theme using the existing Tailwind CSS color variables
export const muiTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#45BC53', // --color-primary (fresh green)
      contrastText: '#FFFFFF', // --color-primary-foreground
    },
    secondary: {
      main: '#FFC529', // --color-secondary (warm yellow)
      contrastText: '#1A1A1A', // --color-secondary-foreground
    },
    error: {
      main: '#EF4444', // --color-error (clear red)
      contrastText: '#FFFFFF', // --color-error-foreground
    },
    warning: {
      main: '#F59E0B', // --color-warning (attention amber)
      contrastText: '#1A1A1A', // --color-warning-foreground
    },
    success: {
      main: '#10B981', // --color-success (confident green)
      contrastText: '#FFFFFF', // --color-success-foreground
    },
    background: {
      default: '#F2F3FD', // --color-background (soft lavender-gray)
      paper: '#FFFFFF', // --color-card (white)
    },
    text: {
      primary: '#1A1A1A', // --color-foreground (near-black)
      secondary: '#6B7280', // --color-muted-foreground (medium gray)
    },
    divider: '#E5E7EB', // --color-border (light gray)
    accent: {
      main: '#FE724C', // --color-accent (energetic orange)
      contrastText: '#FFFFFF', // --color-accent-foreground
    }
  },
  typography: {
    fontFamily: "'Inter', sans-serif",
    h1: { fontFamily: "'Inter', sans-serif" },
    h2: { fontFamily: "'Inter', sans-serif" },
    h3: { fontFamily: "'Inter', sans-serif" },
    h4: { fontFamily: "'Inter', sans-serif" },
    h5: { fontFamily: "'Inter', sans-serif" },
    h6: { fontFamily: "'Inter', sans-serif" },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
          border: '1px solid #E5E7EB',
          '&:hover': {
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
          borderRadius: 8,
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
  },
});

// Custom color utility for accessing theme colors
export const customColors = {
  accent: '#FE724C',
  accentForeground: '#FFFFFF',
  destructive: '#EF4444',
  destructiveForeground: '#FFFFFF',
};